import { render, staticRenderFns } from "./BuildingEstimatesHeader.vue?vue&type=template&id=b7802b34&"
import script from "./BuildingEstimatesHeader.vue?vue&type=script&lang=js&"
export * from "./BuildingEstimatesHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports